import { z } from 'zod';

const legalReasonObjectSchema = z.object({
    id: z.string().optional(),
    name: z.string().min(1).optional(),
    /** @deprecated Prefer name — kept for older clients */
    reason: z.string().optional(),
    description: z.string().optional(),
    lawArticle: z.string().optional(),
    article: z.string().optional(),
    code: z.string().optional(),
    /** @deprecated Prefer lawArticle/article */
    lawReference: z.string().optional(),
    scope: z.enum(['m5', 'm6', 'art6', 'art9', 'other']).optional(),
    jurisdiction: z.enum(['kvkk', 'gdpr']).optional(),
    forSensitiveData: z.boolean().optional(),
    status: z.enum(['active', 'inactive']).optional(),
    customFields: z.record(z.unknown()).optional(),
});

function requireNameOrReason(schema) {
    return schema.superRefine((data, ctx) => {
        if (!data.name && !data.reason) {
            ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['name'], message: 'name is required' });
        }
    });
}

export const LegalReasonSchema = requireNameOrReason(legalReasonObjectSchema);
export const CreateLegalReasonSchema = requireNameOrReason(legalReasonObjectSchema);
export const UpdateLegalReasonSchema = legalReasonObjectSchema.partial();
